import { render, staticRenderFns } from "./DavichNumberEdit.vue?vue&type=template&id=0a7e0de2&scoped=true&"
import script from "./DavichNumberEdit.vue?vue&type=script&lang=js&"
export * from "./DavichNumberEdit.vue?vue&type=script&lang=js&"
import style0 from "./DavichNumberEdit.vue?vue&type=style&index=0&id=0a7e0de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e0de2",
  null
  
)

export default component.exports